import { CustomFormReport } from '@flicent/fieldpulse-react-component-library-frontend';

import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  token: string;
  isInternalPdf: boolean;
  publicLinkIdForFilesSummarySection?: number;
  customFormReportIdForFilesSummarySection?: number;
  customFormReport: CustomFormReport;
}

interface ResponseDataType {
  is_task_queued: boolean;
  pdf_file_display_name: string | null;
  pdf_file_url: string | null;
}

export const generateAndSaveCustomFormReportPdfRequest = ({
                                                            token,
                                                            isInternalPdf,
                                                            publicLinkIdForFilesSummarySection,
                                                            customFormReportIdForFilesSummarySection,
                                                            customFormReport,
                                                          }: RequestParams): Promise<ResponseDataType> => {
  return ApiServiceInstance.makeRequest(`/custom-form-report/pdf/preview/generate-and-save`, {
    method: 'POST',
    token,
    body: {
      is_internal_pdf: isInternalPdf,
      public_link_id_for_files_summary_section: publicLinkIdForFilesSummarySection,
      custom_form_report_id_for_files_summary_section: customFormReportIdForFilesSummarySection,
      custom_form_report: customFormReport,
    },
  });
};